export const newMailAction = "hab";
export const newNoteAction = "iab";
export default {newMailAction,newNoteAction};